const BASE_WIDTH = 375;
const MIN_WIDTH = 300;
const MAX_WIDTH = 768;
const ROOT_VALUE = 100;

let resizeTimer = null;

function setRootFontSize() {
  const documentElement = document.documentElement;
  const clientWidth = documentElement.clientWidth;

  if (!clientWidth) {
    return;
  }

  const safeWidth = Math.max(Math.min(clientWidth, MAX_WIDTH), MIN_WIDTH);
  documentElement.style.fontSize = `${(safeWidth / BASE_WIDTH) * ROOT_VALUE}px`;
}

export function initRem() {
  setRootFontSize();

  const handleResize = () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      setRootFontSize();
    }, 30);
  };

  window.__hubeiLeagueRemResize__ = handleResize;
  window.addEventListener('resize', handleResize);
  window.addEventListener('orientationchange', handleResize);
}

export function destroyRem() {
  if (window.__hubeiLeagueRemResize__) {
    window.removeEventListener('resize', window.__hubeiLeagueRemResize__);
    window.removeEventListener('orientationchange', window.__hubeiLeagueRemResize__);
    window.__hubeiLeagueRemResize__ = null;
  }

  window.clearTimeout(resizeTimer);
}

export function designPxToRem(pixelValue) {
  return `${pixelValue / 288}rem`;
}
